import { AuthService } from './../../services/auth.service';
import { Component, OnInit, ViewChild, Renderer2, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { IntervinientesService } from "./../../services/intervinientes.service";

@Component({
  selector: 'app-intervinientes',
  templateUrl: './intervinientes.component.html',
  styleUrls: ['./intervinientes.component.css']
})
export class IntervinientesComponent implements OnInit {
  
  @ViewChild("mensajeInterviniente") mensajeInterviniente: ElementRef;

  filtro={
    nombre :"",
    email: "",
    telefono:"",
    perfil:"",
    activo:true,
    ultimoacceso:""
  };

  ordenacion={};


  intervinientes:any[] = [];

  paginaActual:number=1;
  paginaSiguiente:number;
  paginaAnterior:number;
  totalPaginas:number;

  constructor(private _intervinientesService:IntervinientesService, private renderer:Renderer2,
     private auth:AuthService) {
    
    
  }

  ngOnInit() {
    this.ordenacion['campo']="INfechaultimoacceso";
    this.ordenacion['orden']="DESC";
    this.getIntervinientesPorFiltro();
  }

  getIntervinientesPorFiltro(){
    this._intervinientesService.getIntervinientes(this.filtro, this.paginaActual, this.ordenacion)
        .subscribe( resp =>{
          
          this.intervinientes = resp["intervinientes"];
          this.paginaActual=parseInt(resp["pagina"]);
          this.paginaAnterior=parseInt(resp["pag_anterior"]);
          this.paginaSiguiente=parseInt(resp["pag_siguiente"]);
          this.totalPaginas=parseInt(resp["total_paginas"]);
    });
  }

  limpiarCampos(){
    this.filtro.nombre="";
    this.filtro.email="";
    this.filtro.perfil="";
    this.filtro.activo=true;
    this.filtro.telefono="";
    this.filtro.ultimoacceso="";
  }

  getTodos(){
    this.limpiarCampos();
    this.getIntervinientesPorFiltro();
  }

  checkActivo(i:number){
    let returnValue=false;
    if(this.intervinientes[i].INactivo=="1"){
      returnValue=true;
    }
    return returnValue;
  }

  actualizarEstado(codigo){
    if(confirm("¿Desea cambiar el estado del interviniente?")){
      this._intervinientesService.actualizarEstado(codigo)
      .subscribe(resp=>{
        this.getIntervinientesPorFiltro();
      })
    }
  }

  nextPage(){
    this._intervinientesService.getIntervinientes(this.filtro, this.paginaSiguiente, this.ordenacion)
    .subscribe(resp=>{
      this.intervinientes = resp["intervinientes"];
          this.paginaActual=parseInt(resp["pagina"]);
          this.paginaAnterior=parseInt(resp["pag_anterior"]);
          this.paginaSiguiente=parseInt(resp["pag_siguiente"]);
          this.totalPaginas=parseInt(resp["total_paginas"]);
    });
  }

  previousPage(){
    this._intervinientesService.getIntervinientes(this.filtro, this.paginaAnterior, this.ordenacion)
    .subscribe(resp=>{
      this.intervinientes=resp["intervinientes"];
          this.paginaActual=parseInt(resp["pagina"]);
          this.paginaAnterior=parseInt(resp["pag_anterior"]);
          this.paginaSiguiente=parseInt(resp["pag_siguiente"]);
          this.totalPaginas=parseInt(resp["total_paginas"]);
    });
  }

  ordenarTabla(campo){
    
    if(this.ordenacion['campo']==campo && this.ordenacion['orden']=='DESC'){
      this.ordenacion['orden']='ASC';
    }else{
      this.ordenacion['campo']=campo;
      this.ordenacion['orden']='DESC';
    }

    this.getIntervinientesPorFiltro();
  }

  borrarInterviniente(codinterviniente){
    if(confirm("¿Desea borrar el interviniente seleccionado?")){
      this._intervinientesService.borrarInterviniente(codinterviniente)
      .subscribe(resp=>{
        alert(resp["msg"]);
        this.getIntervinientesPorFiltro();
      });
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/app/components/intervinientes/intervinientes.component.ts